var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentHistoryActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFAE4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8151 17.333V21.7984C18.8261 21.534 18.1112 20.633 18.1112 19.5657C18.1014 18.4983 18.8261 17.5974 19.8151 17.333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.6708V17.6853C13.0282 17.7636 13.8409 18.6253 13.8409 19.6829C13.8507 20.7307 13.0379 21.5925 11.9999 21.6708Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9941 19.5552C16.9941 21.2395 18.2182 22.6496 19.8144 22.9336V25.6265C19.8144 26.1357 19.4031 26.547 18.8939 26.547H14.2522C13.0086 26.547 11.9999 25.5384 11.9999 24.2947V22.7867C13.6451 22.7083 14.9573 21.3374 14.9573 19.6825C14.9573 18.0177 13.6451 16.6566 11.9999 16.5684V15.0604C11.9999 13.8167 13.0086 12.8081 14.2522 12.8081H18.8939C19.4031 12.8081 19.8144 13.2194 19.8144 13.7286V16.1865C18.2084 16.4705 16.9941 17.8708 16.9941 19.5552Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1952 21.7493V17.3818C22.0961 17.6952 22.7425 18.5569 22.7425 19.5656C22.7425 20.5742 22.0864 21.4261 21.1952 21.7493Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9994 17.9989V21.3577C28.0691 21.3577 27.3151 20.6037 27.3151 19.6832C27.3151 18.7529 28.0691 17.9989 28.9994 17.9989Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 15.0604V16.8818C27.8151 16.8818 26.7281 17.6162 26.356 18.7424C25.7195 20.6715 27.1492 22.4635 29 22.4635V24.2849C29 25.5286 27.9914 26.5372 26.7477 26.5372H22.1061C21.5969 26.5372 21.1856 26.1259 21.1856 25.6167V22.9042C22.7132 22.5517 23.8491 21.1905 23.8491 19.5552C23.8491 17.9198 22.7132 16.5586 21.1856 16.2159V13.7286C21.1856 13.2194 21.5969 12.8081 22.1061 12.8081H26.7477C27.9914 12.8081 29 13.8167 29 15.0604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistoryActivity);
export default __webpack_public_path__ + "static/media/paymentHistoryActivity.3eb8380d158c032d510e66edddb2e85f.svg";
export { ForwardRef as ReactComponent };